import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Blog} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/blog'

const createBlog = (blog: Blog): Promise<Blog | undefined> => {
  return axios.post(API_URL, blog)
}

const updateBlog = (blog: Blog): Promise<Blog | undefined> => {
  return axios.patch(`${API_URL}/${blog.id}`, blog)
}

const deleteBlog = (blogId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${blogId}`)
}

export {deleteBlog, createBlog, updateBlog}
